import { useRef, useEffect } from 'react';
import Animated from "react-native-web/dist/exports/Animated";
export var useAnimatedValue = function useAnimatedValue(initialValue) {
  var ref = useRef(new Animated.Value(initialValue));
  return ref.current;
};

var getInitialValue = function getInitialValue(config) {
  if (typeof config.initialValue !== 'undefined') return config.initialValue;else {
    return config.toValue;
  }
};

var getAnimationType = function getAnimationType(config) {
  return config.type || 'timing';
};

export var useAnimation = function useAnimation(config) {
  var animatedValue = useAnimatedValue(getInitialValue(config));

  var animate = function animate() {
    if (config.type === 'timing') {
      Animated.timing(animatedValue, config).start();
    } else if (config.type === 'spring') {
      Animated.spring(animatedValue, config).start();
    } else {
      throw new Error('unsupported animation type=' + config.type);
    }
  };

  useEffect(animate, [config.toValue]);
  return animatedValue;
};